<template>
    <div class="btjcView" v-loading="companyDetailLoading">
        <!--检索公司的输入框-->
        <div class="topSearchCompany">
            <div class="searchBox">
                <div class="searchBoxLeft">公司名称</div>
                <div class="searchBoxInput">
                    <el-input
                        v-model="btjcInput"
                        @input="fillHotWords()"
                        placeholder="请输入您管理的企业进行匹配"
                        class="searchBoxInputV"
                        >
                    </el-input>
                    <div class="searchLenovo" v-if="isShowLenovoList">
                        <div 
                            class="searchLenovoList" 
                            v-for="(item,index) in companyLenovoList" 
                            :key="index"
                            @click="lenovoListClick(item)">
                            {{ item.name }}
                        </div>
                    </div>
                </div>
                <div class="searchBtnBox">
                    <div class="searchBtn" @click="companyDetailSearch">匹配</div>
                </div> 
            </div>
        </div>
        <!--展示匹配结果相关列表-->
        <div v-if="isShowcompanyDetail">
            <!--匹配结果 条数-->
            <div class="companyResultTop">
                <div class="companyTopLeft">匹配结果</div>
                <div class="companyTopRight">
                    <span>共查找到</span>
                    <span class="blueSpan">{{ companyDetailTotal }}条</span>
                    <span>记录，预计本企业可申请资助：总计</span>
                    <span class="blueSpan">{{ award }}</span>
                </div>
                <div class="companyReturn" @click="btbgDetailReturn">返回</div>
            </div>
            <!--匹配结果 的检索-->
            <div class="companyResultSearch">
                <div class="searchBoxLeft">关键词</div>
                <div class="searchBoxInput">
                    <el-input
                        v-model="companyFilterKey"
                        placeholder="请输入关键词搜索"
                        class="searchBoxInputV"
                        >
                    </el-input>
                </div>
                <div class="searchBtnBox">
                    <div class="searchBtn btnA" @click="companyDetailFilter">搜索</div>
                    <div class="searchBtn btnB" @click="companyDetailExport">导出</div>
                </div> 
            </div>
            <!--匹配结果列表-->
            <div class="companyResultDetail" v-if="companyDetailData.length!=0">
                <div class="companyResultDetailScroll">
                    <div 
                        class="companyDetailList" 
                        v-for="(item,index) in companyDetailData" 
                        :key="index"
                        @click="companyDetailListClick(item)">
                        <div class="companyListTitle">
                            <p>{{ item.title }}</p>
                        </div>
                        <div class="companyListDept">
                            <div class="companyListIcon">
                                <img :src="imgObj.icon_dept" alt="">
                                <span>受理部门:</span>
                            </div>
                            <div class="companyListText">
                                <p>{{ item.dept }}</p>
                            </div>
                        </div>
                        <div class="companyListTimeAddress">
                            <div class="companyListTime">
                                <div class="companyListIcon">
                                    <img :src="imgObj.icon_time" alt="">
                                    <span>申报年度:</span>
                                </div>
                                <div class="companyListText">
                                    <p>{{ item.year }}</p>
                                </div>
                                <!-- <div></div>
                                <div>{{ item.year }}</div> -->
                            </div>
                            <div class="companyListAddress">
                                <div class="companyListIcon">
                                    <img :src="imgObj.icon_address" alt="">
                                    <span>地区:</span>
                                </div>
                                <div class="companyListText">
                                    <p>{{ item.area }}</p>
                                </div>
                                <!-- <div></div>
                                <div>{{ item.area }}</div> -->
                            </div>
                        </div>
                        <div class="companyListlevelStar">
                            <div class="companyListIcon">
                                <img :src="imgObj.icon_levelStar" alt="">
                                <span>匹配度:</span>
                            </div>
                            <div class="companyListText">
                                <p>{{ item.levelStar }}</p>
                            </div>
                        </div>
                        <div class="companyListQT">
                            <p class="companyListQTP">
                                <span class="companyListQTLeft">申报时间:</span>
                                <span v-if="item.time">{{ item.time }}</span>
                            </p>
                            <p class="companyListQTP">
                                <span class="companyListQTLeft">支持力度:</span>
                                <span>{{ item.support }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="notData" v-if="btjcInput==''">
            <div class="imgBox">
                <img :src="imgObj.icon_wu" alt=""> 
            </div>
            <p class="notDataText1">还未输入企业</p>
            <p class="notDataText2">请选择您管理的企业进行匹配</p>
        </div>
        <!--详情-->
        <div class="listDetail" v-if="isShowDetail">
            <div class="detailtop">
                <div class="detailTopTitle">{{ detailObj.title }}</div>
                <div class="detailTopDept">
                    <img :src="imgObj.icon_dept" alt="">
                    <span>{{ detailObj.dept }}</span>
                </div>
                <div class="detailTopTime">
                    <img :src="imgObj.icon_time" alt="">
                    <span v-if="detailObj.startTime">{{ detailObj.startTime }}</span>
                    <span v-else>暂无</span>
                    <span style="margin:0 6px;">至</span>
                    <span v-if="detailObj.endTime">{{ detailObj.endTime }}</span>
                    <span v-else>暂无</span>
                </div>
                <div class="detailTopClose" @click="closeDetail">返回</div> 
            </div>
            <div class="detailBottom">
                <div class="detailBottomTitle">产品类别</div>
                <div class="detailContentBox">
                    <div class="detailList" v-for="(item,index) in detailObj.industries.split(',')" :key="index">
                        {{ item }}
                    </div>
                </div>
                <div class="detailBottomTitle">申报条件</div>
                <div class="detailContentBox">
                    <p v-html="detailObj.condition"></p>
                </div>
                <div class="detailBottomTitle">产品类别</div>
                <div class="detailContentBox">
                    <p v-html="detailObj.support"></p>
                </div>
                <div class="detailBottomTitle">申报材料</div>
                <div class="detailContentBox">
                    <p v-html="detailObj.materials"></p>
                </div>
                <div class="detailBottomTitle">项目来源</div>
                <div class="detailContentBox">
                    <p v-html="detailObj.announcements"></p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

//图片
import icon_wu from '@/assets/icon/wu.png'
import icon_dept from '@/assets/icon/dept.png'
import icon_time from '@/assets/icon/time.png'
import icon_address from '@/assets/icon/address.png'
import icon_levelStar from '@/assets/icon/levelStar.png'


import { debounce } from 'lodash'

//接口
import { getCompanyList,getCompanyDetail,getCompanyExport } from '@/api/api.js'


export default {
    name:'',
    data(){
        return{
            imgObj:{
                icon_wu,
                icon_dept,
                icon_time,
                icon_address,
                icon_levelStar
            },
            //补贴检测输入框
            btjcInput:'',
            //联想公司列表
            companyLenovoList:[],
            //是否展示联想公司列表
            isShowLenovoList:false,
            companyDetailLoading:false,
            //公司所有详情
            companyDetailData:[],
            companyDetailDataCopy:[],
            //条数
            companyDetailTotal:0,
            //补助金额
            award:'',
            //是否展示公司详情
            isShowcompanyDetail:false,
            //公司详情的筛查关键词
            companyFilterKey:'',
            isShowDetail:false,
            detailObj:{}

        }
    },
    methods:{
        
        //补贴检测输入框
        fillHotWords: debounce(function () {
            //console.log(this.btjcInput,1);
            //清除联想公司列表
            this.companyLenovoList = [];
            let data = {
                keyword:this.btjcInput
            }
            getCompanyList(data).then(res => {
                if(res.status==200&&res.data.status==0){
                    this.companyLenovoList = res.data.data;
                    this.isShowLenovoList = true;

                    //是否为空
                    if(this.companyLenovoList.length==0){
                        this.isShowLenovoList = false
                    }
                }
            }).catch(err => {
                console.log(err)
            })
        },500),
        //公司联想点击 
        lenovoListClick(item){
            //选中 放到输入框
            this.btjcInput = item.name;
            //隐藏列表展示
            this.isShowLenovoList = false;
        },
        //补贴检测 匹配按钮
        companyDetailSearch(){
            this.companyDetailLoading = true;
            let data = {
                name:this.btjcInput
            }
            getCompanyDetail(data).then(res => {
                if(res.status==200&&res.data.status==0){
                    //console.log(res)
                    this.companyDetailData = res.data.data.list;
                    this.companyDetailDataCopy = res.data.data.list;
                    this.companyDetailTotal = res.data.data.count;
                    this.award = res.data.data.totalAward;
                    this.companyDetailLoading = false;
                    //展示
                    this.isShowcompanyDetail = true;
                }
            }).catch(err => {
                console.log(err);
                this.companyDetailLoading = false;
            })
        },
        //补贴报告的一个返回按钮
        btbgDetailReturn(){
            this.isShowcompanyDetail = false;
            this.isShowLenovoList = true;
        },
        //检测报告搜索
        companyDetailFilter(){
            if (this.companyFilterKey) {
                this.companyDetailData = this.companyDetailDataCopy.filter(item => {
                    return item.title.includes(this.companyFilterKey.trim())
                })
            } else {
                this.companyDetailData = this.companyDetailDataCopy;
            }
        },
        //导出检测报告
        companyDetailExport(){
            let hostname = ''; //document.location.hostname;
            let api = '/zsg/ccw/fastEvalExport?name=';
            let thatUrl = hostname + api + this.btjcInput;
            window.open(thatUrl,'_blank')
            /*debugger
            //加载loading
            this.isShowcompanyDetail = true;
            //调用接口
            let data = {
                name:this.btjcInput,
            }
            getCompanyExport(data).then(res => {
                console.log(res)
                if(res.status==200&&res.data.status==0){
                    this.isShowcompanyDetail = false;
                    
                }
            })*/
        },
        //检测报告列表点击
        companyDetailListClick(item){
            console.log(item);
            const detail = JSON.parse(JSON.stringify(item))
            detail.condition = this.getHtml(detail.condition)
            detail.support = this.getHtml(detail.support)
            detail.materials = this.getHtml(detail.materials, true)
            let tips = ''
            if (detail.announcements.includes("（因政府机构改革，该链接可能已失效，请留意最新动态。）")) {
                tips = this.getTips("因政府机构改革，该链接可能已失效，请留意最新动态。")
            } else {
                tips = this.getTips('如无法链接到原站点相关文章，请点击查看相关<span class="handlerhover" onclick="zcyw()">政策原文</span>')
            }
            detail.announcements = this.getHtml(detail.announcements, true)

            this.detailObj = detail

            this.isShowDetail = true;
        },
        //关闭详情
        closeDetail(){
            this.isShowDetail = false;
            this.detailObj = {}
        },

        getTips(t) {
            return '<p style="color:red;" class="font12"><i class="icon ico cc_tanhao" style="font-size:12px"></i>'.concat(t, "</p>")
        },
        getHtml(str, e) {
            if ("" === str) {
                return "-";
            }
            if (str = str.replace(/\r\n/g, "<br>").replace(/\n/g, "<br>"), e) {
                /* const a = /(?:(http|https):\/\/)?([\.0-9A-Z_a-z]+[\/-9A-Z_a-z]*\.[\.0-9A-Z_a-z]+[\/-9A-Z_a-z]*\??[%&\+0-9=A-Z_a-z]*)/gi;
                str = str.replace(a, '<p><a href="$1://$2" class="goto-article" target="_blank">$1://$2</a></p>') */
                let urlPattern = /(https?:\/\/|www\.)[a-zA-Z_0-9\-@]+(\.\w[a-zA-Z_0-9\-:]+)+(\/[\(\)~#&\-=?\+\%/\.\w]+)?/g;
                str = str.replace(urlPattern, function(match) {
                    var href = match;
                    if (match.indexOf("http") == -1) {
                        href = "http://" + match;
                    }
                    return "<a class=\"goto-article\"  target=\"_blank\" href=\"" + href + "\">" + match + "</a>";
                });
                console.log(str, 70)
            }
            return str
        },
        getHref(content) {
            if (!content) {
                return "";
            }
            let urlPattern = /(https?:\/\/|www\.)[a-zA-Z_0-9\-@]+(\.\w[a-zA-Z_0-9\-:]+)+(\/[\(\)~#&\-=?\+\%/\.\w]+)?/g;
            content = content.replace(urlPattern, function(match) {
                var href = match;
                if (match.indexOf("http") == -1) {
                    href = "http://" + match;
                }
                return "<a target=\"_blank\" href=\"" + href + "\">" + match + "</a>";
            });
            return content;
        },
    }
}
</script>
<style scoped lang="scss">
.btjcView{
    width:100%;
    min-height:360px;
    position: relative;
}
.listDetail{
    width:102%;
    height: 757px;
    overflow-y: auto;
    background: #ffffff;
    position: absolute;
    top:0;
    left:-2px;
    z-index:999;
    .detailtop{
        width:100%;
        height:130px;
        position: relative;
        box-sizing: border-box;
        padding:20px;
        background: #EEF8FF;
        box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
        margin-top: 10px;
        .detailTopTitle{
            color: #111111;
            font-size: 18px;
            font-weight: 700;
        }
        .detailTopDept{
            margin-top:12px;
            img{
                width:17px;
                height:17px;
                position: relative;
                top:2px;
                margin-right:4px;
            }
            color: #0F59A4;
            font-weight: 700;
            font-size: 17px;
        }
        .detailTopTime{
            margin-top:12px;
            img{
                width:17px;
                height:17px;
                position: relative;
                top:2px;
                margin-right:4px;
            }
            color: #0F59A4;
            font-weight: 700;
            font-size: 17px;
        }
        .detailTopClose{
            width:60px;
            height:30px;
            line-height: 30px;
            text-align: center;
            color:#ffffff;
            background: linear-gradient(270deg, #0F59A4 0%, #0F59A4 100%) !important;
            font-size: 15px;
            cursor:pointer;
            position: absolute;
            top:5px;
            right:20px;
            border-radius:2px;
        }
    }
    .detailBottom{
        width:100%;
        margin-top:18px;
        .detailList:nth-child(5n) {
            margin-right: 0px !important;
        }
        .detailList{
            width:calc(20% - 16px);
            height:40px;
            text-align: center;
            line-height: 40px;
            float:left;
            margin-right:20px;
            margin-bottom:10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            background: #F8F8F8;
            //background: red;
        }
        .detailBottomTitle{
            width:100%;
            height:50px;
            line-height: 50px;
            background: #EEF8FF;
            box-sizing: border-box;
            padding-left:20px;
            color: #0F59A4;
            font-weight: 700;
            font-size: 18px;
        }
        .detailContentBox ::v-deep{
            a{
                color:blue;
            }
        }
        .detailContentBox{
            width:100%;
            overflow: hidden;
            box-sizing: border-box;
            padding:12px 0;
            p{
                line-height:28px ;
                text-indent:32px;
                font-size: 16px;
                color:#111111;
            }
        }
    }
}
.topSearchCompany{
    width: 100%;
    height:85px;
    z-index: 999;
    position: relative;
    background: #EEF8FF;
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
    .searchBox{
        width:100%;
        .searchBoxLeft{
            width:166px;
            height:85px;
            line-height: 85px;
            font-size: 18px;
            font-weight: 700;
            color:#333333;
            box-sizing: border-box;
            padding-right:18px;
            text-align: right;
            float:left;
        }
        .searchBoxInput{
            width:480px;
            height:85px;
            float:left;
            box-sizing: border-box;
            padding-top:20px;
            .searchBoxInputV ::v-deep .el-input__inner{
                width:100%;
                height:42px;
                line-height: 42px;
                border-radius:0;
                border: 2px solid #e1e1e1;
                font-size:16px;
            }
        }
        .searchBtnBox{
            width:calc(100% - 646px);
            height:85px;
            float:left;
            box-sizing: border-box;
            padding:20px;
            .searchBtn{
                width:100%;
                height:40px;
                line-height: 40px;
                text-align: center;
                cursor:pointer;
                color: #FFFFFF !important;
                background: linear-gradient(270deg, #0F59A4 0%, #0F59A4 100%) !important;
                
            }
        }
    }
    .searchLenovo{
        width:100%;
        max-height:300px;
        border: 1px solid #D8D8D8;
        background: #ffffff;
        box-sizing: border-box;
        padding:4px 20px;
        overflow-y: auto;
        .searchLenovoList{
            width:100%;
            min-height:20px;
            font-size:16px;
            line-height: 20px;
            padding:8px 0;
            color:#8C8C8C;
            cursor:pointer;
        }
    }
}
.companyResultTop{
    width:100%;
    height:42px;
    position: relative;
    background: #EEF8FF;
    margin-top:10px;
    .companyTopLeft{
        width:130px;
        height:40px;
        line-height: 40px;
        float:left;
        box-sizing: border-box;
        padding-left:20px;
        font-size: 18px;
        font-weight: 700;
        color:#0F59A4;
    }
    .companyTopRight{
        width:calc(100% - 130px);
        height:40px;
        line-height: 40px;
        float:left;
        font-size: 16px;
    }
    .companyReturn{
        width:60px;
        height:30px;
        line-height: 30px;
        text-align: center;
        color:#ffffff;
        background: linear-gradient(270deg, #0F59A4 0%, #0F59A4 100%) !important;
        font-size: 15px;
        cursor:pointer;
        position: absolute;
        top:5px;
        right:20px;
        border-radius:2px;
    }
}

.companyResultSearch{
    width: 100%;
    height:85px;
    background: #EEF8FF;
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
    margin-top:10px;
    .searchBoxLeft{
        width:166px;
        height:85px;
        line-height: 85px;
        font-size: 18px;
        font-weight: 700;
        color:#333333;
        box-sizing: border-box;
        padding-right:18px;
        text-align: right;
        float:left;
    }
    .searchBoxInput{
        width:calc(100% - 454px);
        height:85px;
        float:left;
        box-sizing: border-box;
        padding-top:20px;
        .searchBoxInputV ::v-deep .el-input__inner{
            width:100%;
            height:42px;
            line-height: 42px;
            border-radius:0;
            border: 2px solid #e1e1e1;
            font-size:16px;
        }
    }
    .searchBtnBox{
        width:268px;
        height:85px;
        float:left;
        box-sizing: border-box;
        padding:20px 0;
        .searchBtn{
            width:124px;
            height:40px;
            line-height: 40px;
            text-align: center;
            cursor:pointer;
            float:left;
        }
        .btnA{
            color: #FFFFFF !important;
            background: #0F59A4!important;
        }
        .btnB{
            color:  #0F59A4!important;
            background:  #FFFFFF!important;
            margin-left:20px;
        }
    }
}
.companyResultDetail{
    width:816px;
    height:520px;
    overflow-y: auto;
    .companyResultDetailScroll{
        width:810px;
        overflow: hidden;
        .companyDetailList:nth-child(2n) {
            margin-left: 10px !important;
        }
        .companyDetailList{
            width:400px;
            height:250px;
            float:left;
            box-sizing: border-box;
            padding:0px 15px;
            background: #EEF8FF;
            box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
            margin-top: 10px;
            .companyListTitle{
                width:100%;
                height:46px;
                display: grid;
                p{
                    align-self: center;
                    /*justify-self: center;*/
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    color:#111111;
                    font-size:18px;
                    font-weight: 700;
                }
            }
            .companyListDept{
                width:100%;
                height:46px;
                .companyListIcon{
                    width:100px;
                    height: 46px;
                    line-height: 46px;
                    float:left;
                    color: #0F59A4;
                    font-weight: 700;
                    font-size:17px;
                    img{
                        width:17px;
                        height:17px;
                        position: relative;
                        top:2px;
                        margin-right:4px;
                    }
                }
                .companyListText{
                    width:calc(100% - 100px);
                    height: 46px;
                    float:left;
                    display: grid;
                    p{
                        align-self: center;
                        /*justify-self: center;*/
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        color:#111111;
                        font-size:16px;
                        font-weight: 400;
                    }
                }
            }
            .companyListTimeAddress{
                width:100%;
                height:40px;
                .companyListTime{
                    width:50%;
                    height:40px;
                    float:left;
                    .companyListIcon{
                        width:100px;
                        height: 40px;
                        line-height: 40px;
                        float:left;
                        color: #0F59A4;
                        font-weight: 700;
                        font-size:17px;
                        img{
                            width:17px;
                            height:17px;
                            position: relative;
                            top:2px;
                            margin-right:4px;
                        }
                    }
                    .companyListText{
                        width:calc(100% - 100px);
                        height: 40px;
                        float:left;
                        display: grid;
                        p{
                            align-self: center;
                            /*justify-self: center;*/
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                            color:#111111;
                            font-size:16px;
                            font-weight: 400;
                        }
                    }
                }
                .companyListAddress{
                    width:50%;
                    height:40px;
                    float:left;
                    .companyListIcon{
                        width:70px;
                        height: 40px;
                        line-height: 40px;
                        float:left;
                        color: #0F59A4;
                        font-weight: 700;
                        font-size:17px;
                        img{
                            width:17px;
                            height:17px;
                            position: relative;
                            top:2px;
                            margin-right:4px;
                        }
                    }
                    .companyListText{
                        width:calc(100% - 70px);
                        height: 40px;
                        float:left;
                        display: grid;
                        p{
                            align-self: center;
                            /*justify-self: center;*/
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                            color:#111111;
                            font-size:16px;
                            font-weight: 400;
                        }
                    }
                }
            }
            .companyListlevelStar{
                width:100%;
                height:40px;
                .companyListIcon{
                    width:84px;
                    height: 40px;
                    line-height: 40px;
                    float:left;
                    color: #0F59A4;
                    font-weight: 700;
                    font-size:17px;
                    img{
                        width:17px;
                        height:17px;
                        position: relative;
                        top:2px;
                        margin-right:4px;
                    }
                }
                .companyListText{
                    width:calc(100% - 90px);
                    height: 40px;
                    float:left;
                    display: grid;
                    p{
                        align-self: center;
                        /*justify-self: center;*/
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        color:#111111;
                        font-size:20px;
                        font-weight: 400;
                        color:#FFAA00;
                    }
                }
            }
            .companyListQT{
                width:100%;
                height:100px;
                border-top:1px solid #D8D8D8;
                box-sizing: border-box;
                padding:6px 0;
                color:#8C8C8C;
                margin-top:6px;
                .companyListQTP{
                    overflow:hidden;
                    text-overflow:ellipsis;
                    white-space:nowrap;
                    margin-top:2px;
                    .companyListQTLeft{
                        margin-right:10px;
                    }
                }
                
            }
        }
    }
    
}

.notData{
    width:100%;
    color:#8C8C8C;
    text-align: center;
    .imgBox{
        width:100%;
        margin-top:40px;
        img{
            width:130px;
        }
    }
    .notDataText1{
        font-size: 18px;
        margin-top:20px;
        font-weight: 700;
    }
    .notDataText2{
        font-size: 16px;
        margin-top:10px;
    }
}

.blueSpan{
    color:#0F59A4!important;
}
</style>